









































import { Vue, Prop, Component, Watch, Model } from 'vue-property-decorator';
@Component
export default class AutocompleteUser extends Vue {

  @Prop() private value!: IUser;
  @Prop({ default: () => [] }) private users!: IUser[];
  @Prop({ default: false }) private dense!: boolean;
  @Prop({ default: false }) private flat!: boolean;
  @Prop({ default: false }) private soloInverted!: boolean;
  @Prop({ default: false }) private allowOverflow!: boolean;
  @Prop({ default: false }) private filled!: boolean;
  @Prop({ default: 'Valitse käyttäjä' }) private label!: string;

  search(item: IUser, query: string, itemText: string) {
    return ['name', 'email', 'phoneNumber'].some(s => {
      const propVal = (item as any)[s] + '';
      return propVal.toLowerCase().indexOf(query.toLocaleLowerCase()) >= 0;
    });
  }

}
